import classNames from "classnames";

import { RightPanelMode } from "../../providers/DataPageRightPanelProvider";
import MetadataSummaryIcon from "assets/icons/MetadataSummaryIcon";
import LabelPropagationIcon from "assets/icons/LabelPropagationIcon";

import styles from "./style.module.scss";
import { FlywheelStatus } from "../../../vl-api/vlSchemas";

interface ViewToggleButtonsProps {
  currentView: RightPanelMode;
  onViewChange: (view: RightPanelMode) => void;
  flywheelStatus?: FlywheelStatus | undefined;
  showLabelPropagation?: boolean;
}

const FLYWHEEL_STATUS_TEXT: Partial<Record<FlywheelStatus, string>> = {
  INIT: "INITIALIZING",
  RUNNING: "RUNNING",
  RESUME_FLOW: "RUNNING",
  APPLY_MODEL_TO_DATASET: "RUNNING",
  PAUSED_FOR_REVIEW: "NEEDS REVIEW",
};

const ViewToggleButtons = ({
  currentView,
  onViewChange,
  showLabelPropagation,
  flywheelStatus,
}: ViewToggleButtonsProps) => {
  const summaryButtonClassNames = classNames(styles.toggleButton, {
    [styles.active]: currentView === "summary",
  });
  const labelsButtonClassNames = classNames(styles.toggleButton, {
    [styles.active]: currentView === "labels",
  });

  return (
    <div className={styles.viewToggleContainer}>
      <button
        className={summaryButtonClassNames}
        onClick={() => onViewChange("summary")}
      >
        <MetadataSummaryIcon />
      </button>
      {showLabelPropagation && (
        <button
          className={labelsButtonClassNames}
          onClick={() => onViewChange("labels")}
        >
          <LabelPropagationIcon />
          {flywheelStatus &&
            !["FAILED", "ABORTED", "COMPLETED"].includes(flywheelStatus) && (
              <div
                className={classNames(
                  styles.flywheelStatus,
                  styles[flywheelStatus],
                )}
              >
                {FLYWHEEL_STATUS_TEXT[flywheelStatus]}
              </div>
            )}
        </button>
      )}
    </div>
  );
};

export default ViewToggleButtons;
